import angular from "angular";
import authService from "./auth.service";

angular
    .module('core.userCan', [authService])
    .directive('userCan', ['Auth', 'ngIfDirective', function (Auth, ngIfDirective) {

        let ngIf = ngIfDirective[0];

        return {
            transclude: ngIf.transclude,
            priority: ngIf.priority - 1,
            terminal: ngIf.terminal,
            restrict: ngIf.restrict,
            link: function(scope, element, attributes) {

                let initialNgIf = attributes.ngIf;
                let ifEvaluator;
                let permission = attributes.userCan;
                let isReverse = !!attributes.userCanReverse;

                let res = Auth.can(permission);
                if (isReverse) {
                    res = !res;
                }

                if (initialNgIf) {
                    ifEvaluator = function () {
                        return scope.$eval(initialNgIf) && res;
                    }
                } else {
                    ifEvaluator = function () {
                        return res;
                    }
                }

                attributes.ngIf = ifEvaluator;
                ngIf.link.apply(ngIf, arguments);
            }
        };
    }]);

export default 'core.userCan';


// WEBPACK FOOTER //
// ./resources/assets/modules/core/user-can.directive.js